import PropTypes from 'prop-types';

Optional.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
};

function formatOptional(value) {
  if (Array.isArray(value)) return formatOptional(value.join(', '));

  return value ? value : '-';
}

export default function Optional({value}) {
  return (
    <span>{ formatOptional(value) }</span>
  );
}